import React from 'react'
import type { Answer } from 'types/answers'
import type { Quest } from 'types/quests'
import OrdinalChatUpvalueControl from './OrdinalChatUpvalueControl'

type SimpleUpvalueModalProps = {
    answer: Answer
    signalQuest?: Quest
    open: boolean
    onClose: () => void
    selectedReaction?: string | null
    onReactionSelected?: (emoji: string) => void
    onReactionCommitted?: () => void
}

/**
 * Controlled version of the compact upvalue sheet. Trigger surfaces retain
 * their existing quick-action behavior and opt into this presentation only.
 */
export default function SimpleUpvalueModal({
    answer,
    signalQuest,
    open,
    onClose,
    selectedReaction,
    onReactionSelected,
    onReactionCommitted,
}: SimpleUpvalueModalProps) {
    return (
        <OrdinalChatUpvalueControl
            answer={answer}
            signalQuest={signalQuest}
            controlledOpen={open}
            initialSelectedEmoji={selectedReaction}
            modalOnly
            onRequestClose={onClose}
            onReactionSelected={onReactionSelected}
            onReactionCommitted={onReactionCommitted}
            // The sheet always shows an armed paid amount, matching the
            // authoritative-amount semantics of the existing picker.
            actionSource="signal_options"
        />
    )
}
